import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import { UnifiedDataTable } from "../../../layout/unified-data-table/ui/unified-data-table";
import type {
  UnifiedDataTableColumnRenderers,
  UnifiedTableRecord,
} from "../../../shared/ui/data-table/model/data-table-contract";

import * as Styled from "./appointments.styled";

interface IPatientInfoOutletContext {
  setIsStretchContent: React.Dispatch<React.SetStateAction<boolean>>;
}

const appointmentsRecord: UnifiedTableRecord = {
  module: "appointments",
  pageTitle: "Appointments",
  sections: [
    {
      id: "appointments",
      title: "Appointments",
      tables: [
        {
          id: "appointments-table",
          columns: [
            {
              key: "date",
              header: "Date",
              sortable: true,
              width: 140,
              rendererId: "appointmentDate",
            },
            { key: "checkIn", header: "Check In", sortable: true, width: 110 },
            { key: "started", header: "Started", sortable: true, width: 110 },
            {
              key: "checkOut",
              header: "Check Out",
              sortable: true,
              width: 120,
            },
            { key: "gender", header: "Gender", sortable: true, width: 100 },
            {
              key: "caregiver",
              header: "Caregiver",
              sortable: true,
              width: 190,
            },
            {
              key: "location",
              header: "Location",
              sortable: true,
              width: 240,
              rendererId: "wrappingCell",
            },
            {
              key: "comments",
              header: "Comments",
              sortable: true,
              width: 280,
              rendererId: "wrappingCell",
            },
          ],
          rows: [
            {
              date: "04/04/2022 10:15 AM",
              checkIn: "10:42 AM",
              started: "10:45 AM",
              checkOut: "11:45 AM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - N/ UTI",
            },
            {
              date: "11/27/2017 04:55 PM",
              checkIn: "04:52 PM",
              started: "04:57 PM",
              checkOut: "05:37 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - NEW // nausea diarrhea",
            },
            {
              date: "10/15/2017 03:05 PM",
              checkIn: "02:54 PM",
              started: "03:10 PM",
              checkOut: "03:47 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - EST/ CONGESTION",
            },
            {
              date: "09/28/2017 12:45 PM",
              checkIn: "12:43 PM",
              started: "12:51 PM",
              checkOut: "01:21 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - EST/ CHEST CONGESTION FOLLOW UP",
            },
            {
              date: "09/21/2017 11:45 AM",
              checkIn: "11:43 AM",
              started: "11:50 AM",
              checkOut: "12:52 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - Est/ chest congestion",
            },
            {
              date: "08/22/2017 02:00 PM",
              checkIn: "01:55 PM",
              started: "01:58 PM",
              checkOut: "03:04 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - EST/ FOLLOW UP & RESULTS",
            },
            {
              date: "08/17/2017 08:45 AM",
              checkIn: "08:35 AM",
              started: "08:39 AM",
              checkOut: "09:17 AM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - Est/ Follow up * Dr Goldstein",
            },
            {
              date: "08/14/2017 08:25 AM",
              checkIn: "08:25 AM",
              started: "08:34 AM",
              checkOut: "09:56 AM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - Est/ 3rd shot",
            },
            {
              date: "08/13/2017 03:25 PM",
              checkIn: "03:04 PM",
              started: "03:48 PM",
              checkOut: "04:35 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - EST/ INJECTION",
            },
            {
              date: "08/12/2017 01:50 PM",
              checkIn: "01:48 PM",
              started: "02:04 PM",
              checkOut: "03:19 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - EST PT// URI//SINUS-COLD SYMPTOMS",
            },
            {
              date: "02/24/2017 05:15 PM",
              checkIn: "05:28 PM",
              started: "07:30 PM",
              checkOut: "08:22 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - newpt// poss uti",
            },
            {
              date: "02/12/2017 01:40 PM",
              checkIn: "01:42 PM",
              started: "01:59 PM",
              checkOut: "02:49 PM",
              gender: "Female",
              caregiver: "Urgent Care, BCHC",
              location: "Bonita Community Health Center",
              comments: "Urgent Care - NEW PT//POSS UTI",
            },
          ],
          ui: {
            searchable: true,
            searchPlaceholder: "Search...",
            searchKeys: [
              "date",
              "checkIn",
              "started",
              "checkOut",
              "gender",
              "caregiver",
              "location",
              "comments",
            ],
            downloadable: ["csv", "xls", "pdf"],
            showTableDownloads: true,
            defaultRowsPerPage: 10,
            rowsPerPageOptions: [5, 10, 20, 25],
          },
        },
      ],
    },
  ],
};

const splitDateTime = (value: unknown) => {
  const [date = "—", ...timeParts] = String(value ?? "—").split(" ");
  const time = timeParts.join(" ");

  return { date, time };
};

export const Appointments = () => {
  const outletContext = useOutletContext<
    IPatientInfoOutletContext | undefined
  >();
  const setIsStretchContent = outletContext?.setIsStretchContent;
  const contentScrollerRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!setIsStretchContent) {
      return;
    }

    setIsStretchContent(true);

    return () => {
      setIsStretchContent(false);
    };
  }, [setIsStretchContent]);

  const columnRenderers = React.useMemo<UnifiedDataTableColumnRenderers>(
    () => ({
      appointmentDate: ({ value }) => {
        const { date, time } = splitDateTime(value);

        return (
          <Styled.DateCell>
            <span>{date}</span>
            {time ? <span>{time}</span> : null}
          </Styled.DateCell>
        );
      },
      wrappingCell: ({ value }) => (
        <Styled.WrappingCell>{String(value ?? "—")}</Styled.WrappingCell>
      ),
    }),
    [],
  );

  return (
    <Styled.Container>
      <Styled.Title>Appointments</Styled.Title>
      <UnifiedDataTable
        record={appointmentsRecord}
        columnRenderers={columnRenderers}
        useSharedSectionNav
        scrollContainerRef={contentScrollerRef}
      />
    </Styled.Container>
  );
};
